var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',_vm._b({attrs:{"switch":""},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},'b-form-checkbox',{ disabled: _vm.disabled },false),[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }